module.exports = "<svg id=551b8ffb-7fa7-4b99-b2e5-3a91599c11dc data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>Error</title><path d=M12,21a9,9,0,1,0-9-9A9,9,0,0,0,12,21ZM12,4a8,8,0,1,1-8,8A8,8,0,0,1,12,4Z /><path d=M12,14.79a.76.76,0,0,0,.75-.75V6.22a.75.75,0,1,0-1.5,0V14A.76.76,0,0,0,12,14.79Z /><circle cx=12 cy=17.03 r=0.75 /></svg>";


//////////////////
// WEBPACK FOOTER
// ../~/html-loader!../~/@printos/gazelle/src/extensions/grid/images/error.svg
// module id = 156
// module chunks = 0